import apiClient from "./apiClient";

const BASE = "/api/Tooth";

// API returns toothID (no `id`) — alias it so list/edit code using `.id` works.
const withId = (t) => ({ ...t, id: t.toothID });

export const getTeeth = async () => {
  const res = await apiClient.get(`${BASE}/all`);
  return { ...res, data: (res.data || []).map(withId) };
};
export const createTooth = (data) => apiClient.post(`${BASE}/save`, data);
export const updateTooth = (id, data) => apiClient.post(`${BASE}/save`, { ...data, toothID: id });
export const deleteTooth = (id) => apiClient.delete(`${BASE}/${id}`);
